/* jshint esversion: 6 */
import { filter, mergeMap } from 'rxjs/operators';
import api from 'app/redux/api.js';
import {
    ShortenerActions
} from 'app/redux/actions.js';
import * as constants from 'app/redux/constants.js';


export const fetchShortenersEpic = (action$, state$) => action$.pipe(
    filter(action => (action.type === constants.SHORTENER_LIST && action.status === constants.STATE_TXRX)),
    mergeMap(action => api(action.type, state$, null, null, ShortenerActions.receiveShorteners))
);

export const fetchShortenerEpic = (action$, state$) => action$.pipe(
    filter(action => (action.type === constants.SHORTENER_SHOW && action.status === constants.STATE_TXRX)),
    mergeMap(action => api(action.type, state$, action.id, null, ShortenerActions.receiveShortener))
);

export const shortenerUpdateEpic = (action$, state$) => action$.pipe(
    filter(action => (action.type === constants.SHORTENER_UPDATE && action.status === constants.STATE_TXRX)),
    mergeMap(action => api(action.type, state$, null, action.post, ShortenerActions.updatedShortener))
);

export const shortenerDeleteEpic = (action$, state$) => action$.pipe(
    filter(action => (action.type === constants.SHORTENER_DELETE && action.status === constants.STATE_TXRX)),
    mergeMap(action => api(action.type, state$, action.id, null, ShortenerActions.deletedShortener))
);

export const shortenerCreateEpic = (action$, state$) => action$.pipe(
    filter(action => (action.type === constants.SHORTENER_CREATE && action.status === constants.STATE_TXRX)),
    mergeMap(action => api(action.type, state$, null, action.post, ShortenerActions.createdShortener))
);

export const setDefaultShortenerEpic = (action$, state$) => action$.pipe(
    filter(action => (action.type === constants.SHORTENER_SET_DEFAULT && action.status === constants.STATE_TXRX)),
    mergeMap(action => api(action.type, state$, null, action.post, ShortenerActions.confirmDefaultShortener))
);

export const applyShortenerEpic = (action$, state$) => action$.pipe(
    filter(action => (action.type === constants.SHORTENER_APPLY && action.status === constants.STATE_TXRX)),
    mergeMap(action => api(action.type, state$, null, action.post, ShortenerActions.confirmApplyShortener))
);

export const fetchShortenerLogEpic = (action$, state$) => action$.pipe(
    filter(action => (action.type === constants.SHORTENER_LOG && action.status === constants.STATE_TXRX)),
    mergeMap(action => api(action.type, state$, action.id, null, ShortenerActions.receiveShortenerLog))
);

export const testShortenerEpic = (action$, state$) => action$.pipe(
    filter(action => (action.type === constants.SHORTENER_TEST && action.status === constants.STATE_TXRX)),
    mergeMap(action => api(action.type, state$, action.id, null, ShortenerActions.receiveShortenerTest))
);
